import moment from 'moment';
import { useCallback, useEffect, useRef, useState } from 'react';

export const useTimer = (totalSeconds, gapSecondsToTick, onTickHandler, onCompeleteHandler) => {
  const [secondRemaining, setSecondRemaining] = useState(gapSecondsToTick);
  const intervalId = useRef(null);

  const clearIntervalId = useCallback(
    () => intervalId.current && clearInterval(intervalId.current),
    []
  );

  const resetTimer = useCallback(() => {
    clearIntervalId();
    const { startDate, endDate } = getDateBounders(totalSeconds, gapSecondsToTick);
    createInterval(startDate, endDate);
  }, [totalSeconds, gapSecondsToTick, clearIntervalId, createInterval]);

  const executeWithOmittingTimer = callback => {
    clearIntervalId();
    callback();
  };

  const getDateBounders = (totalSeconds, gapSecondsToTick) => {
    const now = moment();
    return {
      startDate: moment(now).add(totalSeconds - gapSecondsToTick, 'seconds'),
      endDate: moment(now).add(totalSeconds, 'seconds')
    };
  };

  const createInterval = useCallback(
    (startDate, endDate) => {
      intervalId.current = setInterval(() => {
        const now = moment();
        if (startDate.isAfter(now)) {
          return;
        }

        if (startDate.isSameOrBefore(now)) {
          onTickHandler();
        }

        if (endDate.isSameOrBefore(now)) {
          clearInterval(intervalId);
          onCompeleteHandler();
          clearIntervalId();
          return;
        }

        setSecondRemaining(endDate.diff(now, 'seconds'));
      }, 1000);
    },
    [onTickHandler, onCompeleteHandler, clearIntervalId]
  );

  useEffect(() => {
    return clearIntervalId;
  }, [clearIntervalId]);

  return { secondRemaining, resetTimer, executeWithOmittingTimer };
};
